import React, { useEffect } from "react";
import useScroll from "react-router-scroll/lib/useScroll";
import { Router, applyRouterMiddleware } from "react-router";
import { Provider } from "react-redux";
import { flatMapDeep } from "lodash";
import { IntlProvider } from "react-intl";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import * as theme from "./theme";
import Bugsnag from "./utils/bugsnag";
import ReactGA from "react-ga";

import Sidebar from "./components/Sidebar";
import agenda from "./agenda";

ReactGA.initialize("UA-61215343-12");

const routes = {
  component: Sidebar,
  childRoutes: flatMapDeep(agenda, (a) => a.routes),
};

const muiTheme = getMuiTheme(
  {},
  {
    toggle: { trackOnColor: theme.primaryColor },
    menuItem: { selectedTextColor: theme.secondaryColor },
    textField: { focusColor: theme.primaryColor },
    flatButton: { textColor: "white" },
    checkbox: { checkedColor: theme.primaryColor },
    datePicker: { selectColor: theme.primaryColor },
    timePicker: {
      accentColor: theme.primaryColor,
      headerColor: theme.primaryColor,
    },
  },
);

const AppRouter = ({ store, history }) => {
  useEffect(() => {
    agenda.forEach((a) => {
      if (a.init instanceof Function) {
        a.init(store.dispatch);
      }
    });
  }, [store]);

  const fireTracking = () => {
    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
  };

  return (
    <Provider store={store}>
      <MuiThemeProvider muiTheme={muiTheme}>
        <IntlProvider locale="cs-CZ">
          <Router
            history={history}
            routes={routes}
            render={applyRouterMiddleware(useScroll())}
            onUpdate={fireTracking}
          />
        </IntlProvider>
      </MuiThemeProvider>
    </Provider>
  );
};

export default AppRouter;
